import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const PurchaseProposal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [artwork, setArtwork] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    const fetchArtwork = async () => {
      const { data, error } = await supabase
        .from('artworks')
        .select('*')
        .eq('id', id)
        .eq('is_public_for_sale', true)
        .single();

      if (error || !data) {
        setError("Œuvre non trouvée ou indisponible.");
      } else {
        setArtwork(data);
      }
      setIsLoading(false);
    };

    fetchArtwork();
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Votre proposition d'achat a bien été envoyée. Nous vous contacterons rapidement.");
    navigate('/dashboard');
  };

  if (isLoading) return <div className="p-6">Chargement...</div>;

  if (error) {
    return (
      <div className="p-6">
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">⚠️ Attention :</strong>
          <span className="block sm:inline"> {error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Faire une offre pour "{artwork.title}"</h1>
      <p className="mb-4 text-sm text-gray-600">
        Artiste : {artwork.artist} | Année : {artwork.year} | Technique : {artwork.medium}
      </p>
      <p className="mb-4 text-green-700 font-semibold">
        Prix affiché : € {artwork.sale_price || 'Non défini'} (hors taxes et frais)
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium">Votre nom</label>
          <input type="text" name="name" required className="w-full p-2 border rounded" onChange={handleChange} />
        </div>
        <div>
          <label className="block text-sm font-medium">Votre e-mail</label>
          <input type="email" name="email" required className="w-full p-2 border rounded" onChange={handleChange} />
        </div>
        <div>
          <label className="block text-sm font-medium">Message / Offre</label>
          <textarea name="message" rows="4" className="w-full p-2 border rounded" placeholder="Je souhaite faire une offre de..." onChange={handleChange}></textarea>
        </div>
        <button type="submit" className="btn-artsy btn-primary-artsy">
          Envoyer ma proposition
        </button>
      </form>
    </div>
  );
};

export default PurchaseProposal;
